import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  padding: 40px;
  width: 360px;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  gap: 10px;

  img {
    height: 32px;
  }

  span {
    font-size: 1.4em;
    font-weight: 600;
    color: #333;
  }
`;

const Title = styled.div`
  font-size: 1.3em;
  font-weight: 500;
  color: #333;
  margin-bottom: 24px;
  text-align: center;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
`;

const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 4px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  position: relative;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  color: #aaa;
  font-size: 0.85em;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e0e0e0;
  }

  span {
    padding: 0 10px;
  }
`;

const DomainHint = styled.div`
  font-size: 0.78em;
  color: #aaa;
  text-align: center;
  margin-bottom: 20px;
`;

const GoogleButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 0.95em;
  color: #3c4043;
  transition: background 0.2s;

  &:hover {
    background: #f8f9fa;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SnackbarMessage = styled.span``;

export default {
  Container,
  Card,
  Logo,
  Title,
  Form,
  InputContainer,
  ButtonContainer,
  Divider,
  DomainHint,
  GoogleButton,
  Loader,
  SnackbarMessage,
};



// WEBPACK FOOTER //
// ./src/pages/FirebaseLogin/styles.js